import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Autocomplete2 from "@material-ui/lab/Autocomplete";
import moment from "moment";
import React from "react";
import reg from "../../../../firebase";
import SnackBar from "../../SnackBar";
import styles from "./styles";
const firebase = require("firebase");
require("firebase/firestore");

class Solicitudes extends React.Component {
  constructor() {
    super();
    this.state = {
      guardadoSnack: false,
      exito: false,
      casos: null,
      selectedNoteIndex: null,
      selectedNote: null,
      cuenta: 1,
      ano: null,
      title: "",
      open: false,
      guardado: false,
      open2: false,
      noteId: "",
      open3: false,
      usuarios: [],
      cliente: "",
      email: "",
      rfc: "",
      nvo: false,
      go: true,
      nuevoCaso: false
    };
  }

  componentDidMount = async () => {
    await firebase
      .firestore()
      .collection("solicitudes")
      .orderBy("timestamp", "desc")
      .onSnapshot(serverUpdate => {
        const notes = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });
        // console.log("Asignado.js componentDidMount", notes);
        this.setState({ casos: notes });
      });
    let cityRef = await firebase
      .firestore()
      .collection("contadorCasos")
      .doc("cuenta");
    let getDoc = cityRef
      .get()
      .then(async doc => {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          const data = doc.data();
          if (data.ano == new Date().getFullYear()) {
            let cuenta = data.cuenta;
            cuenta++;
            await this.setState({
              title: `${cuenta}-${new Date().getFullYear()}`,
              cuenta: cuenta
            });
          } else {
            await this.setState({
              title: `1-${new Date().getFullYear()}`,
              cuenta: 1
            });
          }
        }
      })
      .catch(err => {
        console.log("Error getting document", err);
      });
    this.cargarUsuario();
  };

  cargarUsuario = async () => {
    firebase
      .firestore()
      .collection("usuarios")
      .orderBy("nombre", "asc")
      .where("rol", "==", "cliente")
      .onSnapshot(serverUpdate => {
        const usuarios = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });

        this.setState({ usuarios });
        // console.log(usuarios);
      });
  };

  selectNote = async (note, index) => {
    await this.setState({
      selectedNoteIndex: index,
      selectedNote: note,
      open: !this.state.open
    });
  };

  handleCloseD = () => {
    this.setState({
      open: !this.state.open
    });
  };

  deleteNote = async note => {
    this.setState({ noteId: note.id, open2: !this.state.open2 });
  };
  add = note => {
    this.setState({
      selectedNote: note,
      open3: !this.state.open3,
      nuevoCaso: true
    });
  };
  agregar = async note => {
    /* console.log(
      this.state.cliente,
      this.state.email,
      this.state.rfc,
      "cliente"
    );*/
    if (this.state.nvo) {
      try {
        const f = await reg.registerC(
          this.state.cliente,
          this.state.email,
          this.state.rfc,
          "cliente"
        );
        this.setState({ guardadoSnack: true, exito: f });
      } catch (err) {
        console.log(err);
      }
    }
    await firebase
      .firestore()
      .collection("contadorCasos")
      .doc("cuenta")
      .set({
        cuenta: this.state.cuenta,
        ano: new Date().getFullYear()
      });
    await firebase
      .firestore()
      .collection("notes")
      .add({
        title: this.state.title,
        body: note.nombre,
        domicilio: "",
        telefono: note.telefono,
        celular: "",
        email: note.email,
        curp: "",
        rfc: this.state.rfc,
        aseguradora: "",
        ramo: "",
        tiposeguro: "",
        asunto: "",
        monto: "",
        descripcion: "",
        contrato: "",
        honorarios: "",
        anticipo: "",
        asignadoA: "",
        recomendado: "",
        creado: firebase.auth().currentUser.displayName,
        fase1: null,
        fase2: null,
        fase3M: null,
        fase3O: null,
        filterEjecAmp: false,
        filterPresentRecApe: false,
        filterAutoAdmiActora: false,
        filterCitaSent: false,
        estado: 1,
        etapa: "1-Directa",
        descr: "Caso Creado",
        creadoFecha: firebase.firestore.FieldValue.serverTimestamp(),
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });

    let cuenta = this.state.cuenta;
    cuenta++;
    await this.setState({
      title: `${cuenta}-${new Date().getFullYear()}`,
      cuenta: cuenta,
      selectedNote: null,
      open3: !this.state.open3
    });
    firebase
      .firestore()
      .collection("solicitudes")
      .doc(note.id)
      .delete();
    this.handleClick();
  };
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClose2 = () => {
    this.setState({ open2: !this.state.open2 });
  };

  handleClose3 = () => {
    this.setState({
      open3: !this.state.open3,
      go: true,
      rfc: "",
      cliente: "",
      email: ""
    });
  };

  eliminar = () => {
    firebase
      .firestore()
      .collection("solicitudes")
      .doc(this.state.noteId)
      .delete();
    this.setState({ noteId: "", open2: !this.state.open2 });
  };

  updateUsuario = val => {
    this.setState({
      usuario: val,
      email: this.state.usuarios
        .filter(i => i.nombre === val)
        .map(i => {
          //    console.log(i.email);

          return i.email;
        }),
      rfc: this.state.usuarios
        .filter(i => i.nombre === val)
        .map(i => {
          //    console.log(i.contra);
          return i.contra;
        })
    });
  };

  updateEmail = val => {
    this.setState({
      email: val,
      usuario: this.state.usuarios
        .filter(i => i.email === val)
        .map(i => {
          console.log(i.nombre);
          return i.nombre;
        }),
      rfc: this.state.usuarios
        .filter(i => i.email === val)
        .map(i => {
          console.log(i.contra);
          return i.contra;
        })
    });

    // console.log("actualizando los states", this.state.rfc);
  };

  updateRfc = txt => {
    if (this.state.rfc.length >= 5) {
      this.setState({ rfc: txt.target.value, go: false });
    } else {
      this.setState({ rfc: txt.target.value, go: true });
    }
    console.log(this.state.rfc.length);
  };

  buscaUsuario = lok => {
    const k = lok;
    const found = this.state.usuarios.find(({ email }) => email === k);

    if (found) {
      // console.log("busca usuario", found);
      this.setState({
        nvo: false,
        cliente: found.nombre,
        email: found.email,
        rfc: found.contra,
        go: false
      });
    } else {
      // console.log("busca usuario ", lok, " no encontrado");
      this.setState({
        nvo: true,
        rfc: ""
      });
    }
  };

  NuevoUsuario = async () => {
    //console.log("si me ejecuto weeeeeey asdasdasdasdasdas");
    this.setState({ open2: !this.state.open2 });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div>
          <div>
            <Typography variant="h5" gutterBottom>
              Solicitudes
            </Typography>
          </div>
          <div>
            <List>
              <Card>
                <ListItem alignItems="flex-start">
                  <div className={classes.textSection}>
                    <h4
                      className={classes.itemText}
                      style={{ width: "20%", textAlign: "center" }}
                    >
                      Nombre
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "15%", textAlign: "center" }}
                    >
                      Telefono
                    </h4>
                    {/*<h4 className={classes.itemText} style={{ width: "18%" }}>
                      Email
                    </h4>*/}
                    <h4
                      className={classes.itemText}
                      style={{ width: "15%", textAlign: "center" }}
                    >
                      Reclamo
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "27%", textAlign: "center" }}
                    >
                      Asunto
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "8%", textAlign: "center" }}
                    >
                      Fecha
                    </h4>
                  </div>
                  <div
                    className={classes.itemText2}
                    style={{ width: "5%" }}
                  ></div>
                </ListItem>
              </Card>
            </List>
            {this.state.casos ? (
              <List>
                {this.state.casos.map((item, _index) => {
                  return (
                    <Card key={_index} className={classes.card}>
                      <ListItem alignItems="flex-start">
                        <div
                          onClick={() => this.selectNote(item, _index)}
                          className={classes.textSection}
                        >
                          <h4
                            className={classes.itemText2}
                            style={{ width: "20%", textAlign: "center" }}
                          >
                            {item.nombre}
                          </h4>
                          <h4
                            className={classes.itemText2}
                            style={{ width: "15%", textAlign: "center" }}
                          >
                            {item.telefono.length > 20
                              ? `${item.telefono.substr(0, 13)}...`
                              : item.telefono}
                          </h4>
                          {/*<h4
                            className={classes.itemText2}
                            style={{ width: "18%" }}
                          >
                            {item.email.length > 20
                              ? `${item.email.substr(0, 20)}...`
                              : item.email}
                            </h4>*/}
                          <h4
                            className={classes.itemText2}
                            style={{ width: "15%", textAlign: "center" }}
                          >
                            {item.reclamo}
                          </h4>
                          <h4
                            className={classes.itemText2}
                            style={{ width: "27%", textAlign: "center" }}
                          >
                            {item.asunto.substr(0, 45)}...
                          </h4>
                          <h4
                            className={classes.itemText2}
                            style={{ width: "8%", textAlign: "center" }}
                          >
                            {item.timestamp
                              ? moment(item.timestamp.toDate()).format(
                                  "DD/MM/YYYY"
                                )
                              : null}
                          </h4>
                        </div>
                        <div
                          className={classes.itemText2}
                          style={{ width: "5%", marginRight: "5px" }}
                        >
                          <AddIcon
                            onClick={() => {
                              this.buscaUsuario(item.email);
                              this.add(item);
                              this.setState({
                                cliente: item.nombre,
                                email: item.email
                              });
                            }}
                            className={classes.addIcon}
                          />
                          <DeleteIcon
                            onClick={() => this.deleteNote(item)}
                            className={classes.deleteIcon}
                          />
                        </div>
                      </ListItem>
                    </Card>
                  );
                })}
              </List>
            ) : null}
          </div>
        </div>
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.handleCloseD}
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            {/*<DialogTitle id="alert-dialog-title">
              {this.state.selectedNote ? this.state.selectedNote.nombre : ""}
              </DialogTitle>*/}
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <b>Nombre:</b>{" "}
                {this.state.selectedNote ? this.state.selectedNote.nombre : ""}
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                <b>Telefono:</b>{" "}
                {this.state.selectedNote
                  ? this.state.selectedNote.telefono
                  : ""}
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                <b>Email:</b>{" "}
                {this.state.selectedNote ? this.state.selectedNote.email : ""}
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                <b>Tipo de Reclamo:</b>{" "}
                {this.state.selectedNote ? this.state.selectedNote.reclamo : ""}
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                <b>Asunto:</b>
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                {this.state.selectedNote ? this.state.selectedNote.asunto : ""}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseD} color="primary">
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
        <div>
          <Dialog
            open={this.state.open2}
            onClose={this.handleClose2}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"¿Desea eliminar la siguiente solicitud?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose2} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.eliminar} color="primary" autoFocus>
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div>
          <Dialog
            open={this.state.open3}
            onClose={this.handleClose3}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"¿Desea agregar la siguiente solicitud?"}
              {/*/console.log(this.state.selectedNote)*/}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {this.state.nvo
                  ? "Debe crear un usuario para agregar el caso"
                  : " Se encontro el siguiente usuario con los datos"}
              </DialogContentText>

              <Autocomplete2
                id="boxUsuario"
                // className={classes.textField}
                value={this.state.cliente}
                onChange={(obj, str) => this.updateUsuario(str)}
                onClose={params =>
                  console.log(params.target.value, "on closee!!")
                }
                freeSolo
                options={
                  this.state.usuarios
                    ? this.state.usuarios.map(i => {
                        return i.nombre;
                      })
                    : null
                }
                //getOptionLabel={option => option.nombre}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={this.state.cliente}
                    margin="normal"
                    variant="outlined"
                    required
                    fullWidth
                  />
                )}
              />

              <Autocomplete2
                id="boxUsuario"
                // className={classes.textField}
                value={this.state.email}
                onChange={(obj, str) => this.updateEmail(str)}
                onClose={params =>
                  console.log(params.target.value, "on closee!!")
                }
                freeSolo
                options={
                  this.state.usuarios
                    ? this.state.usuarios.map(i => {
                        return i.email;
                      })
                    : null
                }
                //getOptionLabel={option => option.nombre}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={this.state.email}
                    margin="normal"
                    variant="outlined"
                    required
                    fullWidth
                  />
                )}
              />
              {/*** CORREO ELECTRONICO 
              <TextField
                margin="dense"
                id="email"
                value={this.state.email}
                onChange={e => this.updateEmail(e)}
                label="correo electronico"
                variant="outlined"
                type="name"
                required
                fullWidth
              /> ***/}

              {/*** CONTRASEñA ***/}
              <TextField
                margin="dense"
                id="name"
                value={this.state.rfc}
                onChange={e => this.updateRfc(e)}
                label="RFC"
                variant="outlined"
                type="name"
                fullWidth
                autoComplete="off"
                required
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={this.handleClose3} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={() => this.agregar(this.state.selectedNote)}
                color={this.state.go ? "primary" : "secondary"}
                disabled={this.state.go}
                autoFocus
              >
                Agregar
              </Button>{" "}
            </DialogActions>
          </Dialog>
        </div>
        <SnackBar
          open={this.state.guardado}
          exito={this.state.exito}
          handleClose={() => {
            this.setState({ guardado: false, exito: false });
          }}
        />
      </div>
    );
  }
}

export default withStyles(styles)(Solicitudes);
